var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,6.5C4,5,5.2,3.8,6.7,3.8h5V2h-5C4.2,2,2.2,4,2.2,6.5V12H4V6.5z M11.8,12V5.4h-0.2L10,6.6V12H11.8z M9.3,7 L9.3,7l0,4.9H7.5V8.3L9.3,7z M5.1,10.1V12h1.8V8.8L5.1,10.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQs);
export default __webpack_public_path__ + "static/media/qs.1ec287f0.svg";
export { ForwardRef as ReactComponent };